var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"79c69fe777d64e1f79a604ba27e19f2bedabf5a2"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app-20-next@plant-for-the-planet"]={id:"79c69fe777d64e1f79a604ba27e19f2bedabf5a2"};
      